export class ApiResponse {
    constructor() {
    }

    toJSON() {
        // used to transfer the object to JSON
        throw 'not implemented';
    }
}
